import React, { Component } from 'react'
import CustomizedsearchBar from './searchBar'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { styles } from '../CSS/Styles'
import CardContent from '@material-ui/core/CardContent'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import moment from 'moment'

function desc(a, b, orderBy) {
    if (orderBy == null) {
        orderBy= Object.keys(a)[0]
    }
    if (b[orderBy] < a[orderBy]) {
        return -1
    }
    if (b[orderBy] > a[orderBy]) {
        return 1
    }
    return 0
}

function getSorting(order, orderBy) {
    //console.log(order)
    //console.log(orderBy)

    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

let initeFinish = false

// table template
// on default, it contains color code, and can be configure in the colorScheme.

// need to pass in :
//            titleText : table title text, string,
// (Optional) titleAttach : a MUI object such as button.
// (Optional) preTableText : table subtitle
//            tableHeader : table header, list of strings
//            data : data, list of JSON file with {header: data}
// (Optional) tableHeaderMap : table header map, a JSON data that match table header with data header.
// (Optional) clickEvent : row click callback event => will pass in the entire row data information in JSON.
// (Optional) searchBar: using search bar or not, default is not to use

class CustomizedTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tableTitleText: this.props.titleText,
            tableTitleAttach: this.props.titleAttach,
            preTableText: this.props.preTableText,
            tableHeader: this.props.tableHeader,
            data: this.props.data,
            tableHeaderMap: this.props.tableHeaderMap,
            rowClickEvent: this.props.clickEvent,
            order: this.props.order == null ? 'asc' : this.props.order,
            orderBy: this.props.orderBy,
            searchBar: this.props.searchBar
        }
        this.onSearchBarChange = this.onSearchBarChange.bind(this)
        this.sortingHandler = this.sortingHandler.bind(this)
    }

    onSearchBarChange = (search) => {
        this.setState( { data: search } )
        // when filter start, it means the initialize finished, (can not put in WillUpdate, because the initial call for that function
        // may not fetch the data (due to the way react works, (auto-Optimized))
        initeFinish = true
    }

    componentWillUpdate(prevProps) {
        if (this.state.data !== prevProps.data  && initeFinish == false) {
            this.setState( {
                tableTitleText: this.props.titleText,
                tableTitleAttach: this.props.titleAttach,
                preTableText: this.props.preTableText,
                tableHeader: this.props.tableHeader,
                data: this.props.data,
                tableHeaderMap: this.props.tableHeaderMap,
                rowClickEvent: this.props.clickEvent,
                order: this.props.order == null ? 'asc' : this.props.order,
                orderBy: this.props.orderBy,
                searchBar: this.props.searchBar
            } )
        }
    }

    sortingHandler(predbOrderBy, orderby) {
        let dbheaderorderBy = this.state.tableHeaderMap == null ? orderby : this.state.tableHeaderMap[orderby]

        if (predbOrderBy == dbheaderorderBy) {
            this.setState({ order: this.state.order == 'desc'? 'asc':'desc' })
        }else{
            this.setState({ order: 'asc' })
        }

        this.setState({ orderBy: dbheaderorderBy})
    }

    render() {
        let { classes } = this.props
        let tableRowIndex = 0
        // have to use switch because classes.XXX is a styling variable which can not be treated as value of a JSON file
        let colorScheme = ((content)=>{
            switch (content){
            case 'High':
                return classes.red
            case 'Medium':
                return classes.orange
            case 'Low':
            case 'On Track':
                return classes.green
            case 'Completed':
                return classes.grey
            default:
                return classes.black
            }
        })

        return (
            <CardContent>
                <Typography variant = 'h6' align='center'>
                    {this.state.tableTitleText}
                </Typography>
                {this.state.tableTitleAttach}
                <Typography align='left'>
                    {this.state.preTableText}
                </Typography>

                {/* have to pass in all the data to filter, that is why pass in props.data instead of state.data */}
                {this.state.searchBar == null ? null : <CustomizedsearchBar data = {this.props.data} searchCallBack = {this.onSearchBarChange}/>}

                <Table padding='dense'>
                    <TableHead>
                        <TableRow>
                            {this.state.tableHeader.map((header)=>{
                                return (
                                    <TableCell style={{ whiteSpace:'nowrap' }} onClick={()=>{ this.sortingHandler(this.state.orderBy, header) }}>{header}</TableCell>)
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.data == null ? null : this.state.data
                            .sort(getSorting(this.state.order, this.state.orderBy))
                            .map((data)=>{
                                return (
                                    <TableRow
                                        key = {tableRowIndex++}
                                        hover = {this.state.rowClickEvent !=null }
                                        onClick = {()=>{
                                            if (this.state.rowClickEvent !=null) {
                                                this.state.rowClickEvent(data)
                                            }
                                        }}
                                    >
                                        {this.state.tableHeader.map((header)=>{
                                            let cellData = this.state.tableHeaderMap == null ? data[header] : data[this.state.tableHeaderMap[header]]
                                            if (header.match(/(d|D)ate/) || header.match(/(t|T)ime/)) {
                                                return (
                                                    <TableCell style={{whiteSpace:'nowrap'}}>
                                                        <div className={ classes.table_cell }>{moment(cellData).format('DD-MM-YYYY')}</div>
                                                    </TableCell>
                                                )
                                            }
                                            if (header.match(/Ref$/)) {
                                                return (
                                                    <TableCell>
                                                        <div className={ classes.table_cell }>{tableRowIndex}</div>
                                                    </TableCell>
                                                )
                                            }
                                            return (
                                                <TableCell className={colorScheme(cellData)}>
                                                    <div className={ classes.table_cell }>{cellData}</div>
                                                </TableCell>)
                                        })}
                                    </TableRow>
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </CardContent>
        )
    }
}
export default withStyles(styles)(CustomizedTable);


// WEBPACK FOOTER //
// ./src/components/CSSComponent/table.js